export const group = {
  modal: {
    remove: {
      content: `Are you sure you want to delete the group <b>{name}<b>?`
    },
    add_contact_method: {
      description: `
            You can create a new contact method in the section <a href="/pbx/operators/contacts" target="_blank">Contacts</a>
          `
    },
    add_time: {
      description: `
            You can add new ones in the section <a href="/pbx/time-conditions" target="_blank">Schedules</a>, after which they are available for selection.
          `
    }
  },

  form: {
    title: {
      edit: 'Group name'
    },

    field: {
      name: 'Name',
      work_time: 'Work time'
    },

    button: {
      add_time: 'Choose a schedule',
      add_contact_method: 'Choose contact method'
    }
  }
};
